<template>
  <div>
    <iframe className="roadmap-box" id="box-roadmap" title="roadmap"
            src="https://azcronos.com.br/roadmaps/?categoria=7"/>
  </div>
</template>
<script>
export default {
  name: 'Roadmap',
}
</script>

<style scoped lang="stylus">
iframe
  border 0px
  margin-left 0px
  height 1100px
  margin-top 0px
  width 100%
</style>
